import Head from 'next/head'

type JsonLdScriptProps = {
  /** Stable next/head key so re-renders replace rather than duplicate the tag. */
  id: string
  data: Record<string, unknown>
}

// JSON-LD must be serialised with JSON.stringify: CMS copy routinely contains
// quotes and newlines, which hand-built JSON emits unescaped (= invalid
// schema). `<` is escaped so content can never close the script tag early.
export const JsonLdScript = ({ id, data }: JsonLdScriptProps) => (
  <Head>
    <script
      type="application/ld+json"
      key={id}
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({ '@context': 'https://schema.org', ...data }).replace(/</g, '\\u003c'),
      }}
    />
  </Head>
)
